import { FC, ReactElement, ReactNode, useEffect, useState } from 'react';

interface IProps {
	children: ReactNode;
	width?: number;
}

export const Desktop: FC<IProps> = ({ children, width = 992 }) => {
	const [visible, setVisible] = useState(false);

	const calculate = (): void => {
		const current = window.innerWidth >= width;
		setVisible(current);
	};

	useEffect(() => {
		calculate();
		window.addEventListener('resize', calculate);
		return () => {
			window.removeEventListener('resize', calculate);
		};
	}, []);

	return visible ? (children as ReactElement) : null;
};
